import styled from "styled-components";

export default styled.div`
  @media screen and (min-width: 769px) {
    position: relative;
    z-index: 100000;
  }
`;
